import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import RequestsDetailsSectionInfo from './details/sections/RequestsDetailsSectionInfo';

import RequestsEvents from './RequestsEvents';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<RequestsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="reqs_descriptionhtml"
				value={props.model.reqs_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			{/* <InlineTitle text="DIALOG_REQUESTS_ATTACHED_FILES" />
			<DetailsSectionAttachedFiles {...props} /> */}
		</>
	),
	events: RequestsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
